<template>
  <div>
    <div v-if="entity">
      <component :entity="entity" :is="entityClass" />
      <hr />
      <div class="columns is-centered">
        <div class="column is-5">
          <b-field :label="$t('compTransitionActionViewCommon.contact')">
            <b-notification :closable="false">
              <b-tooltip
                :label="$t('compTransitionActionViewCommon.send-email')"
                type="is-black"
              >
                <b-button
                  type="is-small"
                  tag="a"
                  :href="generateMailTo(entity, action)"
                  icon-left="envelope"
                >
                  {{ action.displayContact() }}
                </b-button>
              </b-tooltip>
            </b-notification>
          </b-field>
        </div>
      </div>
    </div>

    <hr />
    <div v-if="action">
      <action-view
        :action="action"
        :withQuota="withQuota"
        :quota="quota"
        :maxQuota="maxQuota"
        :actionQuota="actionQuota"
      ></action-view>
    </div>
  </div>
</template>

<script>
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'ActionView',
  props: {
    action: {
      type: Object,
      required: true
    },
    entity: {
      type: Object,
      required: true
    },
    quota: {
      type: Number,
      required: false,
      default: 0
    },
    maxQuota: {
      type: Number,
      required: false,
      default: 0
    },
    actionQuota: {
      type: Number,
      required: false,
      default: 0
    },
    withQuota: {
      type: Boolean,
      required: false,
      default: false
    },
    generateMailTo: {
      type: Function,
      required: true
    }
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    entityClass: function () {
      return this.coreStore.entityClass
    }
  },
  components: {
    Laboratory: () =>
      import('@/components/transition/ActionViewCommon/Laboratory.vue'),
    Entity: () => import('@/components/transition/ActionViewCommon/Entity.vue'),
    'action-view': () => import('@/components/transition/actions/View.vue')
  }
}
</script>
